var _circle, _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#5F99FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2728 9.13637L13.2046 12.7186L9.06822 12.7186L7.00003 9.13637L9.06822 5.55417L13.2046 5.55417L15.2728 9.13637Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98285 16.8687C10.1371 17.1172 10.357 17.3183 10.6182 17.4499C10.8794 17.5815 11.1719 17.6384 11.4634 17.6145C11.7549 17.5906 12.0341 17.4867 12.2704 17.3143C12.5067 17.1418 12.6908 16.9076 12.8025 16.6372C12.9142 16.3669 12.9491 16.071 12.9034 15.7821C12.8578 15.4932 12.7333 15.2225 12.5437 14.9998C12.3541 14.7771 12.1067 14.611 11.8288 14.5198C11.5508 14.4287 11.2532 14.416 10.9685 14.4831",
    stroke: "white",
    strokeWidth: 0.760239,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5455,
    y: 12.4849,
    width: 1.18182,
    height: 2.36364,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.36365,
    y: 5,
    width: 3.54546,
    height: 0.78788,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevage);
export default __webpack_public_path__ + "static/media/Levage.0e1236c9b0d2beb502cdec3728f25e71.svg";
export { ForwardRef as ReactComponent };